import { useDialog } from '@gokrew/ui';
import { useCrmFormat } from './crm-format';
import { CrmLiveDemoEditor } from './CrmLiveDemos';
import styles from './Crm.module.css';

/** Opens the new AI demo dialog, for a deal (from its panel) or for anyone. */
export const useLiveDemoCreate = () => {
  const { t } = useCrmFormat();
  const { openDialog } = useDialog();
  return (deal?: { id: string; name: string }) =>
    openDialog({
      title: t('crm.live_demo.new'),
      containerClass: styles.editorDialog,
      content: <CrmLiveDemoEditor deal={deal} />,
    });
};
